<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado :elementos="encabezado" />
      <v-card>
        <v-card-text>
          <v-container>
            <v-tabs vertical centered fixed-tabs color="#459345">
              <v-tab> <v-icon left> mdi-account </v-icon> Información </v-tab>
              <v-tab> <v-icon left> mdi-lock </v-icon> Acceso </v-tab>
              <v-tab> <v-icon left> mdi-access-point </v-icon> Contacto </v-tab>
              <v-tab> <v-icon left> mdi-map-marker </v-icon> Dirección</v-tab>
              <v-tab> <v-icon left> mdi-school </v-icon> Escolaridad</v-tab>
              <v-tab @click="findSign">
                <v-icon left> mdi-draw </v-icon> Firma</v-tab
              >

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <validation-observer ref="observer1" v-slot="{ invalid }">
                      <v-form @submit.prevent="updateData" id="form1">
                        <v-row>
                          <v-col md="4">
                            <validation-provider
                              v-slot="{ errors }"
                              name="CURP"
                              rules="required|max:18|min:18"
                            >
                              <v-text-field
                                prepend-icon="mdi-account"
                                v-model="modelData.curp"
                                :counter="18"
                                label="CURP*"
                                required
                                :error-messages="errors"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col md="4">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Fecha nacimiento"
                              rules="required"
                            >
                              <vc-date-picker v-model="modelData.birthDate">
                                <template v-slot="{ inputValue, inputEvents }">
                                  <v-text-field
                                    prepend-icon="mdi-calendar"
                                    class="bg-white border px-2 py-1 rounded"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    required
                                    label="Fecha de nacimiento"
                                    :error-messages="errors"
                                  />
                                </template>
                              </vc-date-picker>
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Nombre"
                              rules="required|max:60"
                            >
                              <v-text-field
                                prepend-icon="mdi-account"
                                v-model="modelData.name"
                                label="Nombre(s)*"
                                :counter="60"
                                required
                                :error-messages="errors"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Primer apellido"
                              rules="required|max:60|min:2"
                            >
                              <v-text-field
                                prepend-icon="mdi-card-account-details"
                                v-model="modelData.firstLastname"
                                label="Primer apellido*"
                                :counter="60"
                                required
                                :error-messages="errors"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Segundo apellido"
                              rules="max:60|min:2"
                            >
                              <v-text-field
                                prepend-icon="mdi-card-account-details-outline"
                                v-model="modelData.secondLastname"
                                label="Segundo apellido (opcional)"
                                :counter="60"
                                :error-messages="errors"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Sexo"
                              rules="required"
                            >
                              <v-autocomplete
                                prepend-icon="mdi-gender-male-female"
                                v-model="modelData.gender"
                                label="Sexo*"
                                :items="genders"
                                :error-messages="errors"
                                no-data-text="Sin resultados"
                              ></v-autocomplete>
                            </validation-provider>
                          </v-col>
                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Estado civil"
                              rules="required"
                            >
                              <v-autocomplete
                                prepend-icon="mdi-account-heart"
                                v-model="modelData.maritalStatus"
                                no-data-text="Sin resultados"
                                label="Estado civil*"
                                :items="maritalsStatus"
                                required
                                :error-messages="errors"
                              ></v-autocomplete>
                            </validation-provider>
                          </v-col>
                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Nacionalidad"
                              rules="required"
                            >
                              <v-autocomplete
                                prepend-icon="mdi-flag-variant-outline"
                                v-model="modelData.nationality"
                                no-data-text="Sin resultados"
                                label="Nacionalidad*"
                                :items="nationality"
                                required
                                :error-messages="errors"
                              ></v-autocomplete>
                            </validation-provider>
                          </v-col>
                          <template
                            v-if="
                              modelData.nationality &&
                                modelData.nationality === 'Otro'
                            "
                          >
                            <v-col cols="3" md="3" sm="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Nombre de Nacionalidad"
                                rules="required|alpha"
                              >
                                <v-text-field
                                  prepend-icon="mdi-flag-variant-outline"
                                  v-model="otherNationality"
                                  label="Nombre de Nacionalidad*"
                                  :error-messages="errors"
                                  :counter="50"
                                  required
                                >
                                </v-text-field>
                              </validation-provider>
                            </v-col>
                          </template>
                        </v-row>
                        <v-row>
                          <v-col md="3" offset-md="9">
                            <div class="d-flex justify-center">
                              <v-col class="d-flex justify-space-around">
                                <v-btn
                                  type="submit"
                                  :disabled="invalid || sending"
                                  color="success"
                                >
                                  <v-icon left>mdi-content-save</v-icon>
                                  Guardar
                                </v-btn>
                              </v-col>
                            </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </validation-observer>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <validation-observer ref="observer2" v-slot="{ invalid }">
                      <v-form
                        @submit.prevent="updateUser"
                        ref="form2"
                        id="form2"
                      >
                        <v-row>
                          <v-col md="4">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Nombre de usuario"
                              rules="required|max:50"
                            >
                              <v-text-field
                                prepend-icon="mdi-account-circle-outline"
                                v-model="modelAccess.username"
                                label="Nombre de usuario*"
                                :counter="50"
                                required
                                :error-messages="errors"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="4" sm="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Contraseña actual"
                              rules="required|max:50"
                            >
                              <v-text-field
                                prepend-icon="mdi-account-key"
                                v-model="modelAccess.currentPassword"
                                autocomplete="off"
                                label="Contraseña actual*"
                                :counter="50"
                                required
                                :error-messages="errors"
                                :append-icon="
                                  showPassword3
                                    ? 'mdi-eye-outline'
                                    : 'mdi-eye-off-outline'
                                "
                                @click:append="showPassword3 = !showPassword3"
                                :type="showPassword3 ? 'text' : 'password'"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col md="4" sm="6">
                            <validation-provider
                              v-slot="{ errors }"
                              name="password"
                              rules="required|max:50"
                            >
                              <v-text-field
                                prepend-icon="mdi-account-key"
                                v-model="modelAccess.password1"
                                autocomplete="off"
                                label="Nueva contraseña*"
                                :counter="50"
                                required
                                :error-messages="errors"
                                :append-icon="
                                  showPassword
                                    ? 'mdi-eye-outline'
                                    : 'mdi-eye-off-outline'
                                "
                                @click:append="showPassword = !showPassword"
                                :type="showPassword ? 'text' : 'password'"
                                ref="password"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col
                            md="4"
                            sm="6"
                            v-if="modelAccess.password1 != null"
                          >
                            <validation-provider
                              v-slot="{ errors }"
                              name="Repetir contraseña"
                              rules="required|max:50|confirmed:password"
                            >
                              <v-text-field
                                prepend-icon="mdi-account-key"
                                v-model="modelAccess.password2"
                                autocomplete="off"
                                label="Repetir contraseña*"
                                :counter="50"
                                required
                                :error-messages="errors"
                                :append-icon="
                                  showPassword2
                                    ? 'mdi-eye-outline'
                                    : 'mdi-eye-off-outline'
                                "
                                @click:append="showPassword2 = !showPassword2"
                                :type="showPassword2 ? 'text' : 'password'"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="3" offset-md="9">
                            <div class="d-flex justify-center">
                              <v-col class="d-flex justify-space-around">
                                <v-btn
                                  type="submit"
                                  :disabled="invalid || sending"
                                  color="success"
                                >
                                  <v-icon left>mdi-content-save</v-icon>
                                  Guardar
                                </v-btn>
                              </v-col>
                            </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </validation-observer>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <validation-observer ref="observer3" v-slot="{ invalid }">
                      <v-form
                        @submit.prevent="updateContactInformation"
                        id="form3"
                      >
                        <v-row>
                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Número telefónico móvil"
                              rules="required|max:10|min:10|numeric|min:10"
                            >
                              <v-text-field
                                v-model="modelContac.phone"
                                label="Número telefónico móvil*"
                                :counter="10"
                                :error-messages="errors"
                                prepend-icon="mdi-cellphone"
                              ></v-text-field>
                            </validation-provider>
                            <!-- <p class="caption text--secondary">
                            Si desconoce el número telefónico utiliza el
                            formato 0000000000
                          </p> -->
                          </v-col>
                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Número telefónico fijo"
                              rules="required|max:10|min:10|numeric|min:10"
                            >
                              <v-text-field
                                v-model="modelContac.homePhone"
                                label="Número telefónico fijo*"
                                :counter="10"
                                prepend-icon="mdi-deskphone"
                                :error-messages="errors"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Correo electrónico"
                              rules="required|max:50|email"
                            >
                              <v-text-field
                                v-model="modelContac.email"
                                label="Correo electrónico*"
                                :counter="50"
                                type="email"
                                :error-messages="errors"
                                prepend-icon="mdi-at"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="3" offset-md="9">
                            <div class="d-flex justify-center">
                              <v-col class="d-flex justify-space-around">
                                <v-btn
                                  type="submit"
                                  :disabled="invalid || sending"
                                  color="success"
                                >
                                  <v-icon left>mdi-content-save</v-icon>
                                  Guardar
                                </v-btn>
                              </v-col>
                            </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </validation-observer>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <validation-observer ref="observer4" v-slot="{ invalid }">
                      <v-form @submit.prevent="updateAddress" id="form4">
                        <v-row>
                          <v-col class="col-md-8">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Calle"
                              rules="required|max:100"
                            >
                              <v-text-field
                                prepend-icon="fas fa-road"
                                v-model="modelAddress.street"
                                :counter="100"
                                label="Calle"
                                :error-messages="errors"
                                required
                              ></v-text-field>
                            </validation-provider>
                          </v-col>

                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Número exterior"
                              rules="required|max:5"
                            >
                              <v-text-field
                                prepend-icon="mdi-pound"
                                v-model="modelAddress.outdoorNumber"
                                :counter="5"
                                label="Número exterior"
                                :error-messages="errors"
                                required
                              ></v-text-field>
                            </validation-provider>
                          </v-col>

                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Número interior"
                              rules="max:5"
                            >
                              <v-text-field
                                prepend-icon="mdi-pound-box-outline"
                                v-model="modelAddress.interiorNumber"
                                :error-messages="errors"
                                :counter="5"
                                label="Número interior"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Código postal"
                              rules="required|max:5|min:1|numeric"
                            >
                              <v-text-field
                                prepend-icon="mdi-mailbox-outline"
                                v-model="modelAddress.postalCode"
                                :counter="5"
                                label="Código postal"
                                :error-messages="errors"
                                required
                                @change="findAddress(false)"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>

                          <v-col v-if="!noPostal">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Entidad federativa"
                              rules="required"
                            >
                              <v-autocomplete
                                prepend-icon="mdi-map-marker-radius"
                                v-model="modelAddress.federalEntityKey"
                                label="Entidad federativa de residencia"
                                :error-messages="errors"
                                :items="federalEntities"
                                :disabled="!validAdress"
                                required
                                auto-select-first
                                :loading="sending"
                                no-data-text="Sin resultados"
                              ></v-autocomplete>
                            </validation-provider>
                          </v-col>

                          <v-col v-if="!noPostal">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Municipio"
                              rules="required"
                            >
                              <v-autocomplete
                                prepend-icon="mdi-map-outline"
                                v-model="modelAddress.municipalityKey"
                                label="Municipio"
                                :error-messages="errors"
                                :items="municipalities"
                                no-data-text="Sin resultados"
                                required
                                :disabled="!validAdress"
                                auto-select-first
                                :loading="sending"
                              ></v-autocomplete>
                            </validation-provider>
                          </v-col>

                          <v-col v-if="!noPostal">
                            <validation-Provider
                              v-slot="{ errors }"
                              name="Colonia"
                              rules="required"
                            >
                              <v-autocomplete
                                prepend-icon="mdi-map-marker"
                                v-model="modelAddress.colonyKey"
                                :items="colonies"
                                :loading="sending"
                                label="Colonia"
                                no-data-text="Sin resultados"
                                :error-messages="errors"
                                :disabled="!validAdress"
                                required
                                auto-select-first
                              ></v-autocomplete>
                            </validation-Provider>
                          </v-col>

                          <v-col cols="12" md="3" sm="12" v-if="noPostal">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Entidad federativa"
                              rules="required"
                            >
                              <v-text-field
                                prepend-icon="mdi-map-marker-radius"
                                v-model="modelAddress.federalEntityKey"
                                label="Entidad federativa de residencia*"
                                :error-messages="errors"
                                required
                              ></v-text-field>
                            </validation-provider>
                          </v-col>

                          <v-col cols="12" md="3" sm="12" v-if="noPostal">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Municipio"
                              rules="required"
                            >
                              <v-text-field
                                prepend-icon="mdi-map-outline"
                                v-model="modelAddress.municipalityKey"
                                label="Municipio*"
                                :error-messages="errors"
                                required
                              ></v-text-field>
                            </validation-provider>
                          </v-col>

                          <v-col cols="12" md="3" sm="12" v-if="noPostal">
                            <validation-Provider
                              v-slot="{ errors }"
                              name="Colonia"
                              rules="required"
                            >
                              <v-text-field
                                prepend-icon="mdi-map-marker"
                                v-model="modelAddress.colonyKey"
                                label="Colonia*"
                                :error-messages="errors"
                                required
                              ></v-text-field>
                            </validation-Provider>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col md="3" offset-md="9">
                            <div class="d-flex justify-center">
                              <v-col class="d-flex justify-space-around">
                                <v-btn
                                  type="submit"
                                  :disabled="invalid || sending"
                                  color="success"
                                >
                                  <v-icon left>mdi-content-save</v-icon>
                                  Guardar
                                </v-btn>
                              </v-col>
                            </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </validation-observer>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <validation-observer ref="observer5" v-slot="{ invalid }">
                      <v-form @submit.prevent="updateSchool" id="form5">
                        <v-row class="mb-3">
                          <v-col class="col-md-4 col-sm-12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Nombre de título"
                              rules="max:100|required"
                            >
                              <v-text-field
                                v-model.trim="modelSchool.name"
                                :counter="100"
                                label="Nombre de título"
                                :error-messages="errors"
                                required
                                prepend-icon="mdi-school"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col class="col-md-4 col-sm-12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Acrónimo"
                              rules="max:10|required"
                            >
                              <v-text-field
                                v-model.trim="modelSchool.acronym"
                                :counter="10"
                                required
                                label="Acrónimo"
                                :error-messages="errors"
                                prepend-icon="mdi-school-outline"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col class="col-md-4 col-sm-12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Cédula Profesional"
                              rules="max:50|required"
                            >
                              <v-text-field
                                v-model.trim="modelSchool.professionalLicense"
                                :counter="50"
                                required
                                label="Cédula Profesional"
                                :error-messages="errors"
                                prepend-icon="mdi-fountain-pen"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="3" offset-md="9">
                            <div class="d-flex justify-center">
                              <v-col class="d-flex justify-space-around">
                                <v-btn
                                  type="submit"
                                  :disabled="invalid || sending"
                                  color="success"
                                >
                                  <v-icon left>mdi-content-save</v-icon>
                                  Guardar
                                </v-btn>
                              </v-col>
                            </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </validation-observer>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <validation-observer ref="observer6" v-slot="{ invalid }">
                      <v-form @submit.prevent="updateSign" id="form5">
                        <v-row>
                          <v-col md="4">
                            <v-file-input
                              accept="image/png, image/jpeg, image/jpg"
                              placeholder="Seleccione la imagen"
                              v-model="filesSign"
                              ref="uploadFile"
                              @change="validateSign"
                              @click:append="validateSign"
                              truncate-length="15"
                              dense
                            ></v-file-input>
                          </v-col>
                          <v-col md="4" align="center" justify="center">
                            <span class="italic" v-if="imageUrl"
                              >Vista previa</span
                            >
                            <br />
                            <img :src="imageUrl" height="150" v-if="imageUrl" />
                          </v-col>

                          <v-col md="4">
                            <div class="d-flex justify-center">
                              <v-col class="d-flex justify-space-around">
                                <v-btn
                                  type="submit"
                                  :disabled="invalid || sending || invalidSign"
                                  color="success"
                                >
                                  <v-icon left>mdi-content-save</v-icon>
                                  Guardar
                                </v-btn>
                              </v-col>
                            </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </validation-observer>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import Sidebar from "../../components/Sidebar.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";
import AutoLogout from "../../components/AutoLogout.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Loader from "@/components/Loader.vue";
import {
  UserRequest,
  CatalogueRequest,
  SepomexRequest,
  AcademicTitleRequest,
  SignRequest,
  PersonRequest,
  ContactInformationRequest,
  AddressRequest,
} from "@/core/request";

export default {
  components: {
    Sidebar,
    ValidationProvider,
    ValidationObserver,
    AutoLogout,
    Encabezado,
    Loader,
  },
  name: "ProfileView",
  data: () => ({
    encabezado: { icono: "mdi-account", texto: "Perfil de usuario" },
    date: new Date(),

    sending: false,
    showPassword: false,
    showPassword2: false,
    showPassword3: false,
    validAdress: false,

    modelData: {},
    modelAccess: {},
    modelContac: {},
    modelAddress: {},
    modelSchool: {},
    modelSign: {},

    //Firma
    filesSign: [],
    invalidSign: true,
    imageUrl: "",
    imageName: "",
    idHumanResource: "",
    //Catalogos
    genders: [
      { text: "Mujer", value: "M" },
      { text: "Hombre", value: "H" },
    ],
    maritalsStatus: [
      { text: "Soltero(a)", value: 1 },
      { text: "Casado(a)", value: 2 },
      { text: "Divorciado(a)", value: 3 },
      { text: "Viudo(a)", value: 4 },
    ],
    colonies: [],
    municipalities: [],
    federalEntities: [],
    nationality: [
      { text: "Mexicana", value: "Mexicana" },
      { text: "Otra", value: "Otro" },
    ],
    otherNationality: "",
    noPostal: false,
  }),
  created() {
    this.validBrowserTab();
    this.getUser();
  },
  computed: {},
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    showResponse(data) {
      let { response, message } = data;
      if (response) {
        this.$utilFront.notifications("Información actualizada.", "SUCCESS");
      } else {
        message = message || "Ocurrió un error al guardar la información.";
        this.$utilFront.notifications(message, "ERROR");
      }
    },
    updateData() {
      this.sending = true;
      if (this.modelData.nationality === "Otro") {
        this.modelData.nationality = this.otherNationality;
      }
      PersonRequest.update(this.modelData)
        .then((res) => {
          this.showResponse(res.data);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    updateUser() {
      this.sending = true;
      UserRequest.update(this.modelAccess)
        .then((res) => {
          this.showResponse(res.data);

          if (res.data.response == true) {
            this.$refs.form2.resetValidation();
            this.modelAccess.currentPassword = "";
            this.modelAccess.password1 = "";
            this.modelAccess.password2 = "";
            this.$refs.form2.reset();
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    updateContactInformation() {
      this.sending = true;
      ContactInformationRequest.update(this.modelContac)
        .then((res) => {
          this.showResponse(res.data);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    updateAddress() {
      this.sending = true;
      AddressRequest.update(this.modelAddress)
        .then((res) => {
          this.showResponse(res.data);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    updateSchool() {
      this.sending = true;
      AcademicTitleRequest.update(this.modelSchool)
        .then((res) => {
          this.showResponse(res.data);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    updateSign() {
      this.sending = true;
      let formData = new FormData();
      formData.append("file", this.filesSign);
      SignRequest.add(formData)
        .then((res) => {
          let { data, status, code } = res.data;
          if (code == 200 && data == true) {
            this.$utilFront.notifications(
              "Información actualizada.",
              "SUCCESS"
            );
            this.filesSign = undefined;
            this.validateSign();
            this.invalidSign = true;
          } else {
            this.$utilFront.notifications(
              "Error al actualizar la información",
              "ERROR"
            );
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    getUser() {
      this.sending = true;
      UserRequest.findUserById({ idUser: this.$utilFront.getIdUser() })
        .then((res) => {
          let { data, code, status } = res.data;
          this.buildData(data);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    buildData(data) {
      let person = data.person;
      this.modelData = {
        idPerson: person.idPerson,
        curp: person.curp,
        birthDate: person.birthDate,
        name: person.name,
        firstLastname: person.firstLastname,
        secondLastname: person.secondLastname,
        gender: person.gender,
        maritalStatus: person.maritalStatus,
      };

      if (person.nationality) {
        this.modelData.nationality = person.nationality;
        if (person.nationality != "Mexicana") {
          this.otherNationality = person.nationality;
          this.modelData.nationality = "Otro";
        }
      }

      this.modelAccess = { username: data.username, idUser: data.idUser };

      if (person.contactInformation) {
        this.modelContac = {
          idContactInformation: person.contactInformation.idContactInformation,
          phone: person.contactInformation.phone,
          homePhone: person.contactInformation.homePhone,
          email: person.contactInformation.email,
        };
      }

      if (person.address) {
        this.modelAddress = Object.assign(person.address);
        this.findAddress(true);
      }

      if (data.academicTitleList) {
        this.modelSchool = Object.assign(data.academicTitleList);
      }
      this.modelSchool.humanResource = {
        idHumanResource: data.idHumanResource,
      };
      this.idHumanResource = data.idHumanResource;
    },
    findAddress(firstLoad) {
      this.sending = true;
      this.validAdress = false;

      (this.colonies = []), (this.municipalities = []);
      this.federalEntities = [];
      
      let postalCode = this.modelAddress.postalCode;

      if (!firstLoad) {
        this.modelAddress.federalEntityKey = "";
        this.modelAddress.municipalityKey = "";
        this.modelAddress.federalEntityKey = "";
      }

      SepomexRequest.listAllByPostalCode({ postalCode: `${postalCode}` })
        .then((res) => {
          let { data, response, message } = res.data;

          this.validAdress = response;

          if (response) {
            this.noPostal = false;
            this.federalEntities = data
              .map((it) => {
                return it.federalEntity;
              })
              .filter(this.onlyUnique);
            this.municipalities = data
              .map((it) => {
                return it.municipality;
              })
              .filter(this.onlyUnique);
            this.colonies = data
              .map((it) => {
                return it.settlement;
              })
              .filter(this.onlyUnique);

            if (!firstLoad) {
              this.modelAddress.federalEntityKey = this.federalEntities[0];
              this.modelAddress.municipalityKey = this.municipalities[0];
              this.modelAddress.colonyKey = this.colonies[0];
            }
          } else {
            this.noPostal = true;
            this.$utilFront.notifications(
              "Código postal no registrado, capturar manualmente.",
              "WARNING"
            );
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    validateSign(value) {
      try {
        if (this.filesSign) {
          let formats = ["image/png", "image/jpeg", "image/jpg"];
          let typeFile = this.filesSign.type;
          let isValidFormat = formats.find((format) => {
            return typeFile == format;
          });
          if (isValidFormat) {
            this.imageName = this.filesSign.name;

            const fr = new FileReader();
            fr.readAsDataURL(this.filesSign);
            fr.addEventListener("load", () => {
              this.imageUrl = fr.result;
            });
            this.invalidSign = false;
          } else {
            // this.$utilFront.notifications( `Formato ${typeFile} no admitido.`, "ERROR");
            this.filesSign = undefined;
            this.invalidSign = true;
            this.filesSign = [];
            this.imageUrl = "";
            this.imageName = "";
            this.invalidSign = true;
          }
        } else {
          this.filesSign = [];
          this.imageUrl = "";
          this.imageName = "";
          this.invalidSign = true;
        }
      } catch (error) {
        //console.log(error);
        this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
      }
    },
    findSign() {
      this.sending = true;
      SignRequest.get({ idHumanResource: this.idHumanResource })
        .then((res) => {
          let { data, message, response } = res.data;
          if (response) {
            this.imageUrl = `data:image/png;base64, ${data}`;
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>
